module.exports = {
	init: function () {
		const categorySelects = document.querySelectorAll('.category-select');
		const categorySelectButtons = document.querySelectorAll('.category-select button');
		const categories = document.querySelectorAll('.category');
		const categoriesContainer = document.querySelector('#categories-container');
		const params = new URL(document.location).searchParams;
		const initialHashLocation = params.get('category').replace(/[^A-Za-z0-9-]/, '');
		// const initialHashLocation = window.location.hash.slice(1);

		// For each of the .category-select lis...
		for (let i = 0; i < categorySelects.length; i++) {
			// ...add a click lister.
			categorySelects[i].addEventListener('click', (e) => {
				categories.forEach((category) => {
					// Hide all category divs containing the information.
					category.classList.remove('show');
					category.setAttribute('aria-hidden', 'true');
					category.setAttribute('aria-expanded', 'false');
					// If the category div matches the id of the selected li, show it.
					if (category.classList.contains(e.target.id)) {
						category.classList.add('show');
						category.setAttribute('aria-hidden', 'false');
						category.setAttribute('aria-expanded', 'true');
						categoriesContainer.style.height = category.offsetHeight + 'px';
					}
				});
				categorySelects.forEach((categorySelect) => {
					// Remove Xs and aria-selected from all lis and buttons.
					categorySelect.classList.remove('current-menu-item');
					categorySelectButtons[i].setAttribute('aria-selected', 'false');
				});
				// Add X and aria-selected to the clicked li/button
				e.target.classList.add('current-menu-item');
				categorySelectButtons[i].setAttribute('aria-selected', 'true');
			});
		}
		categorySelectButtons.forEach((button) => {
			button.addEventListener('click', (e) => {
				// Since we're adding the click event to the li, not the button funnel the button click to the li.
				e.preventDefault();
				e.stopPropagation();
				e.target.parentNode.click();
			});
		});
		// Set the container div height to show the first container.
		categoriesContainer.style.height = categories[0].offsetHeight + 'px';

		// if there's a hash value in the URL, click the li corresponding to the category with that value.
		if (initialHashLocation) {
			const select = document.querySelector('#' + initialHashLocation);
			setTimeout(function () {
				select.click();
				select.firstElementChild.focus();
			}, 1);
		}
	}
};
